import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getLogoImageAltText, getLogoImageUrl } from "../selectors";

const decorate = connect(state => ({
  logoImageUrl: getLogoImageUrl(state),
  logoImageAltText: getLogoImageAltText(state)
}));

const Logo = ({ logoImageUrl, logoImageAltText }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!logoImageUrl) return;

    const img = new Image();
    img.src = logoImageUrl;
    img.onload = () => setLoaded(true);
  }, [logoImageUrl]);

  if (!logoImageUrl) return null;

  return (
    <div
      style={{
        width: "135px",
        minHeight: "100px"
      }}
      tabIndex={0}
    >
      <img
        alt={logoImageAltText}
        src={logoImageUrl}
        width={135}
        height={135}
        fetchPriority="high"
        loading="eager"
        style={{
          objectFit: "cover",
          display: "block",
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.3s ease-in-out"
        }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default decorate(Logo);
